import React from 'react';
import ShoppingCartTable from '../shopping-cart-table/shopping-cart-table';

const CartPage = () => {

  return (
    <div className="cart">
      <ShoppingCartTable />
    </div>
  );
};

export default CartPage;